var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1693_1431)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1693_1431)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48333 2.66669C3.0323 2.66669 2.66667 3.03232 2.66667 3.48335V16.5167C2.66667 16.9677 3.0323 17.3334 3.48333 17.3334H16.5167C16.9677 17.3334 17.3333 16.9677 17.3333 16.5167V3.48335C17.3333 3.03232 16.9677 2.66669 16.5167 2.66669H3.48333ZM0.666668 3.48335C0.666668 1.92775 1.92773 0.666687 3.48333 0.666687H16.5167C18.0723 0.666687 19.3333 1.92775 19.3333 3.48335V16.5167C19.3333 18.0723 18.0723 19.3334 16.5167 19.3334H3.48333C1.92773 19.3334 0.666668 18.0723 0.666668 16.5167V3.48335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 0.666687C6.38562 0.666687 6.83333 1.1144 6.83333 1.66669V18.3334C6.83333 18.8856 6.38562 19.3334 5.83333 19.3334C5.28105 19.3334 4.83333 18.8856 4.83333 18.3334V1.66669C4.83333 1.1144 5.28105 0.666687 5.83333 0.666687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 0.666687C14.7189 0.666687 15.1667 1.1144 15.1667 1.66669V18.3334C15.1667 18.8856 14.7189 19.3334 14.1667 19.3334C13.6144 19.3334 13.1667 18.8856 13.1667 18.3334V1.66669C13.1667 1.1144 13.6144 0.666687 14.1667 0.666687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666668 10C0.666668 9.44772 1.11438 9 1.66667 9H18.3333C18.8856 9 19.3333 9.44772 19.3333 10C19.3333 10.5523 18.8856 11 18.3333 11H1.66667C1.11438 11 0.666668 10.5523 0.666668 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666668 5.83331C0.666668 5.28103 1.11438 4.83331 1.66667 4.83331H5.83333C6.38562 4.83331 6.83333 5.28103 6.83333 5.83331C6.83333 6.3856 6.38562 6.83331 5.83333 6.83331H1.66667C1.11438 6.83331 0.666668 6.3856 0.666668 5.83331Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666668 14.1667C0.666668 13.6144 1.11438 13.1667 1.66667 13.1667H5.83333C6.38562 13.1667 6.83333 13.6144 6.83333 14.1667C6.83333 14.719 6.38562 15.1667 5.83333 15.1667H1.66667C1.11438 15.1667 0.666668 14.719 0.666668 14.1667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 14.1667C13.1667 13.6144 13.6144 13.1667 14.1667 13.1667H18.3333C18.8856 13.1667 19.3333 13.6144 19.3333 14.1667C19.3333 14.719 18.8856 15.1667 18.3333 15.1667H14.1667C13.6144 15.1667 13.1667 14.719 13.1667 14.1667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1667 5.83331C13.1667 5.28103 13.6144 4.83331 14.1667 4.83331H18.3333C18.8856 4.83331 19.3333 5.28103 19.3333 5.83331C19.3333 6.3856 18.8856 6.83331 18.3333 6.83331H14.1667C13.6144 6.83331 13.1667 6.3856 13.1667 5.83331Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1693_1431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1693_1431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonsIcon);
export default __webpack_public_path__ + "static/media/lessons-icon.0b1dbb763ecffd55af59d4164b0a9c06.svg";
export { ForwardRef as ReactComponent };